import {
  ID,
  ResourceMiddlewareFunction,
  ResourceMiddlewareRequestData,
  ResourceModel,
} from '@/request/types'

/**
 * Middleware used for wrapping a singular response in an object. Note, this means
 * that a collection that uses this middleware cannot handle an api response that
 * returns an array of resources.
 *
 * @param key - The key to wrap the data in. e.g. if you provide 'data', and your api returns an array on numbers,
 * your resource will look like { data: [1, 2, 3] }
 * @param id - A function that takes the data and returns the id of the resource.
 * This is used to set the id of the resource, which is required because the object you are
 * wrapping the data in is the top level resource, which requires an id.
 */
export function createWrapSingularResponseInObjectMiddleware<
  Resource extends ResourceModel,
>(
  key: keyof Resource,
  id: (
    requestData: ResourceMiddlewareRequestData<Resource>,
    data: unknown,
  ) => ID,
): ResourceMiddlewareFunction<Resource> {
  return async (requestData, data) => {
    // todo fix the middleware typing so that the input doesn't have to be a resource,
    // all that we really care about is that the data returned is a resource array
    const typeErasedData = data as unknown
    return [
      {
        id: id(requestData, typeErasedData),
        [key]: typeErasedData,
      } as Resource,
    ]
  }
}
